export default function Footer() {
  return (
    <footer className='border-top footer text-muted'>
      <div className='row container mx-3'>
        <p>&copy;{new Date().getFullYear()} By Grant Boyer - All Rights Reserved.</p>
      </div>
    </footer>
  );
}
